import React from "react";
import { NSCA_ROWS, roundTo, fmt, toNum, rpeForPct } from "../lib/calc";

export const NscaTable = ({
  oneRM,
  unit,
  rounding,
  exercise,
  selectedPct,
  onSelectPct,
}) => {
  const rm = toNum(oneRM);
  return (
    <div
      data-testid="nsca-table-container"
      className="tactical-card p-5 sm:p-6 animate-fade"
    >
      <div className="flex items-start justify-between gap-3 flex-wrap mb-5">
        <div>
          <div className="eyebrow">Charge · Répétitions</div>
          <h2 className="font-display text-2xl sm:text-3xl font-extrabold uppercase text-white leading-none mt-1">
            Charges prescrites
          </h2>
          <div className="mt-2 text-xs font-mono text-slate-500 uppercase tracking-widest">
            <span className="text-slate-300">{exercise}</span>{" "}
            <span className="mx-1 text-[#cd383d]">·</span> 1RM ={" "}
            <span className="text-white font-bold tabular">
              {fmt(rm, 0)} {unit}
            </span>
          </div>
        </div>
      </div>

      <div className="overflow-x-auto -mx-2">
        <table className="w-full min-w-[520px] border-collapse">
          <thead>
            <tr className="text-left border-b border-white/10">
              <th className="eyebrow py-2 px-2 text-left">% 1RM</th>
              <th className="eyebrow py-2 px-2 text-left">Reps max</th>
              <th className="eyebrow py-2 px-2 text-left">RPE / RIR</th>
              <th className="eyebrow py-2 px-2 text-right">
                Charge ({unit})
              </th>
            </tr>
          </thead>
          <tbody className="stripe">
            {NSCA_ROWS.map((row) => {
              const load = roundTo((rm * row.pct) / 100, rounding);
              return (
                <tr
                  key={row.pct}
                  data-testid={`nsca-row-${row.pct}`}
                  onClick={() => onSelectPct && onSelectPct(row.pct)}
                  title="Afficher le chargement de barre pour cette charge"
                  className={`border-b border-white/5 cursor-pointer transition ${
                    selectedPct === row.pct
                      ? "bg-[#cd383d]/[0.12] shadow-[inset_3px_0_0_#cd383d]"
                      : "hover:bg-white/[0.04]"
                  }`}
                >
                  <td className="py-2.5 px-2">
                    <span
                      className="font-mono text-lg font-black tabular"
                      style={{ color: row.color }}
                    >
                      {row.pct}%
                    </span>
                  </td>
                  <td className="py-2.5 px-2">
                    <span className="font-mono text-white tabular">
                      {row.reps}
                    </span>
                    <span className="text-slate-600 text-xs ml-1">RM</span>
                  </td>
                  <td className="py-2.5 px-2 whitespace-nowrap">
                    <span className="font-mono text-sm font-bold text-[#cd383d] tabular">
                      {rpeForPct(row.pct).rpe}
                    </span>
                    <span className="text-slate-500 text-[10px] font-mono ml-1.5 uppercase tracking-widest">
                      {rpeForPct(row.pct).rir} RIR
                    </span>
                  </td>
                  <td className="py-2.5 px-2 text-right">
                    <span className="font-mono text-xl font-bold text-white tabular">
                      {fmt(load, rounding ? 0 : 1)}
                    </span>
                    <span className="text-slate-500 text-xs ml-1 uppercase">
                      {unit}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="mt-4 text-[10px] font-mono uppercase tracking-widest text-slate-600">
        Clique une ligne pour voir le chargement de la barre · Barème RPE / RIR :
        RTS (Mike Tuchscherer)
      </div>
    </div>
  );
};
